import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { mfaApi } from './api';

export const MFA_STATUS_KEY = ['mfa', 'status'] as const;

export function useMfaStatus() {
  return useQuery({ queryKey: MFA_STATUS_KEY, queryFn: () => mfaApi.status(), staleTime: 30_000 });
}

/** Every change re-reads the status; nothing secret is ever cached by react-query. */
function useMfaMutation<A, R>(fn: (a: A) => Promise<R>) {
  const qc = useQueryClient();
  return useMutation({ mutationFn: fn, onSettled: () => qc.invalidateQueries({ queryKey: MFA_STATUS_KEY }), gcTime: 0 });
}

export const useStartEnrollment = () => useMfaMutation((pw: string) => mfaApi.start(pw));
export const useConfirmEnrollment = () => useMfaMutation((code: string) => mfaApi.confirm(code));
export const useRegenerateCodes = () => useMfaMutation((a: { currentPassword: string; code: string }) => mfaApi.regenerate(a.currentPassword, a.code));
export const useDisableMfa = () => useMfaMutation((a: { currentPassword: string; code?: string; recoveryCode?: string }) =>
  mfaApi.disable(a.currentPassword, { code: a.code, recoveryCode: a.recoveryCode }));
export const useStepUp = () => useMfaMutation((code: string) => mfaApi.stepUp(code));
